import React from "react";
import "./Main.css";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import lightblue from "./lightblue.jpg";
import puzzle from "./puzzle.jpg";
import appscreenshot from "./appscreenshot2.png"

const Main = () => {
  const buttonStyles = {
    width: "200px",
    padding: "15px 0px",
    fontSize: "10px 0",
    fontWeight: "bold",
    backgroundColor: "#1B1B60",
    margin: "20px -5px",
  };
  return (
    <>
      <div
        id="main"
        style={{
          backgroundImage: `url(${lightblue})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div id="main-text-div">
          <h1>Stablty is here to help your mental health</h1>
          <p>
            We Provide Unique and Exciting Exercises To Help Improve Your Mental
            Health
          </p>
          <Link to="/contact">
            <Button sx={buttonStyles} variant="contained">
              Learn More
            </Button>
          </Link>
        </div>

        <div id="main-image-div">
          <img id="main-image" src={appscreenshot} />
        </div>
      </div>
    </>
  );
};

export default Main;
